var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium/X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0672 15.1829C16.1253 15.241 16.1713 15.3099 16.2027 15.3858C16.2342 15.4617 16.2503 15.543 16.2503 15.6251C16.2503 15.7072 16.2342 15.7885 16.2027 15.8644C16.1713 15.9403 16.1253 16.0092 16.0672 16.0673C16.0091 16.1254 15.9402 16.1714 15.8643 16.2028C15.7884 16.2343 15.7071 16.2505 15.625 16.2505C15.5429 16.2505 15.4616 16.2343 15.3857 16.2028C15.3098 16.1714 15.2409 16.1254 15.1828 16.0673L10 10.8837L4.81719 16.0673C4.69991 16.1846 4.54085 16.2505 4.375 16.2505C4.20915 16.2505 4.05009 16.1846 3.93281 16.0673C3.81554 15.95 3.74965 15.791 3.74965 15.6251C3.74965 15.4593 3.81554 15.3002 3.93281 15.1829L9.11641 10.0001L3.93281 4.81729C3.81554 4.70002 3.74965 4.54096 3.74965 4.3751C3.74965 4.20925 3.81554 4.05019 3.93281 3.93292C4.05009 3.81564 4.20915 3.74976 4.375 3.74976C4.54085 3.74976 4.69991 3.81564 4.81719 3.93292L10 9.11651L15.1828 3.93292C15.3001 3.81564 15.4591 3.74976 15.625 3.74976C15.7909 3.74976 15.9499 3.81564 16.0672 3.93292C16.1845 4.05019 16.2503 4.20925 16.2503 4.3751C16.2503 4.54096 16.1845 4.70002 16.0672 4.81729L10.8836 10.0001L16.0672 15.1829Z",
    fill: "url(#paint0_linear_2827_13501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2827_13501",
    x1: 16.2503,
    y1: 3.74976,
    x2: 3.74965,
    y2: 3.74976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.28b520d51dc38d824e9ff0bee11119c1.svg";
export { ForwardRef as ReactComponent };